class StyleManager {
  private static instance: StyleManager;
  private injectedStyles: Set<string> = new Set();

  private constructor() {}

  public static getInstance(): StyleManager {
    if (!StyleManager.instance) {
      StyleManager.instance = new StyleManager();
    }
    return StyleManager.instance;
  }

  public injectStyles(styleId: string, styleContent: string): void {
    if (this.injectedStyles.has(styleId)) {
      return;
    }

    if (!document.getElementById(styleId)) {
      const styleElement = document.createElement('style');
      styleElement.id = styleId;
      styleElement.textContent = styleContent;
      document.head.appendChild(styleElement);
      this.injectedStyles.add(styleId);
    }
  }

  public hasStyle(styleId: string): boolean {
    return this.injectedStyles.has(styleId);
  }

  public removeStyle(styleId: string): void {
    const styleElement = document.getElementById(styleId);
    if (styleElement) {
      styleElement.remove();
      this.injectedStyles.delete(styleId);
    }
  }
}

export const styleManager = StyleManager.getInstance();
